function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Express = function Express(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M15.19 4.94c4.824 0 8.749 3.924 8.749 8.748s-3.925 8.748-8.748 8.748c-4.824 0-8.748-3.925-8.748-8.748 0-4.824 3.924-8.749 8.748-8.749m0 2a6.755 6.755 0 0 0-6.747 6.748 6.755 6.755 0 0 0 6.748 6.748 6.755 6.755 0 0 0 6.748-6.748 6.755 6.755 0 0 0-6.748-6.749M6.043 18.176a1 1 0 1 1 0 2H4.666a1 1 0 1 1 0-2zm-1.26-2.855a1 1 0 1 1 0 2H2.425a1 1 0 1 1 0-2zM15.19 8.63a1 1 0 0 1 1 1l-.001 3.057h3.172a1 1 0 1 1 0 2h-4.058l-.056-.001-.057.002a1 1 0 0 1-1-1V9.628a1 1 0 0 1 1-1M4.646 12.467a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2zm.136-2.855a1 1 0 1 1 0 2H2.425a1 1 0 1 1 0-2zm1.26-2.854a1 1 0 1 1 0 2H4.666a1 1 0 1 1 0-2zM17.043 2a1 1 0 1 1 0 2h-3.706a1 1 0 1 1 0-2z"
  }));
};
export default Express;